import chairman from "../../assets/images/chairman.jpg";

const CertificateTwo = () => {
  return (
    <section className="certificate">
      <div className="container container--lg">
        <div className="certificate-box px-16 bg-main-600 rounded-16">
          <div className="position-relative py-20">
            <div className="row align-items-center">
              <div
                className="col-xl-4 text-center"
                data-aos="fade-up-left"
                data-aos-duration="900"
              >
                <img
                  src={chairman}
                  alt="Dr. K. P. Gopalkrishna, Chairman"
                  className="rounded-12"
                  style={{ height: 250, objectFit: "contain" }}
                  data-tilt=""
                  data-tilt-max={8}
                  data-tilt-speed={500}
                  data-tilt-perspective={5000}
                  data-tilt-full-page-listening=""
                />
                <h6 className="mt-3 mb-0 text-white">Dr. K. P. Gopalkrishna</h6>
                <p className="mb-0" style={{ color: "#fff", fontSize: 12 }}>
                  Chairman, NPS Group of Institutions, NAFL, and TISB
                </p>
              </div>

              {/* Right: Message */}
              <div className="col-xl-8">
                <div className="certificate__content">
                  <h2
                    className="text-white mb-40 fw-medium"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    A Message from Our Chairman
                  </h2>
                  <p
                    className="mb-0"
                    data-aos="fade-up"
                    data-aos-delay="120"
                    data-aos-duration="900"
                    style={{ color: "#fff" }}
                  >
                    Few things have greater importance to parents than the
                    education of their children. Every parent looks for academic
                    excellence, good values, and discipline for their children.
                    Choosing the right school for them is therefore a crucial
                    decision.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificateTwo;
